/*
 * product-custom-purchase-yummies.js
 * Based on product-custom-purchase-2.js (Rose Nectar)
 * Adapted for Rose Yummies: Choose Offer (option1) x Count (option2)
 *
 * Count selector (30/60) is shown at the top like Nectar's servings (32/64).
 * Subscription options reflect the selected count.
 * When 60 is selected, Buy Once shows a pack grid: 1-Pack (60), 2-Pack (120), 3-Pack (180).
 *
 * Base price = count × $1.16666667 (30=$35, 60=$70, 120=$140, 180=$210)
 * Discount % = (base - actual) / base × 100, rounded
 */

window.Shopify = window.Shopify || {};
window.Shopify.formatMoney =
  window.Shopify.formatMoney ||
  function (cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    const amount = cents / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

document.addEventListener("DOMContentLoaded", () => {
  const FREE_SHIPPING_THRESHOLD_CENTS = 10000;
  const DEFAULT_SHIPPING_TEXT = "$6.95 Shipping";

  // Base price = count × $1.1667 (30 count = $35, 60 count = $70)
  const BASE_PRICE_PER_UNIT_CENTS = 3500 / 30;

  // Read dynamic selling plan data injected by Liquid
  let sellingPlansData = {};
  const spScript = document.getElementById("yummies-selling-plans");
  if (spScript) {
    try {
      sellingPlansData = JSON.parse(spScript.textContent);
    } catch (e) {
      console.warn("Could not parse yummies selling plans", e);
    }
  }

  // Read hardcoded plan ID map injected by Liquid
  let planMap = {};
  const pmScript = document.getElementById("yummies-plan-map");
  if (pmScript) {
    try {
      planMap = JSON.parse(pmScript.textContent);
    } catch (e) {
      console.warn("Could not parse yummies plan map", e);
    }
  }

  const getFormulaBasePrice = (countValue) => {
    const count = parseInt(countValue, 10) || 0;
    return count * BASE_PRICE_PER_UNIT_CENTS;
  };

  // DOM references
  const productForm = document.querySelector(".product-single__form");
  if (!productForm) return;

  const formContainer =
    productForm.closest('[data-section-type="product-template"]') ||
    productForm.closest("[data-product-container]");
  const sectionId = formContainer ? formContainer.dataset.sectionId : null;
  const productJSONScript = formContainer
    ? formContainer.querySelector(`#ProductJson-${sectionId}`)
    : document.querySelector(
        'script[type="application/json"][data-product-json]',
      );

  const productData = productJSONScript
    ? JSON.parse(productJSONScript.textContent)
    : window.customProductData;

  const productTitleElement = document.querySelector(".product-single__title");
  let baseTitle = "";
  if (productTitleElement) {
    baseTitle = productTitleElement.textContent
      .split("|")[0]
      .split("/")[0]
      .trim();
  }

  const productContainer = document.querySelector(
    ".custom-subscription-widget-container",
  );
  const subscriptionIdInput = productForm.querySelector(
    'input[name="selling_plan"]',
  );
  const variantIdInput = productForm.querySelector('[name="id"]');

  const btnTextElement = document.querySelector(".btn--add-to-cart .btn__text");
  const shippingPriceElement = document.querySelector(
    "#buy-once-option .shipping-price",
  );

  const offerRadios = productForm.querySelectorAll('input[name="option1"]');
  const countRadios = productForm.querySelectorAll('input[name="option2"]');
  const purchaseRadios = productContainer
    ? productContainer.querySelectorAll('input[name="purchase_option"]')
    : [];

  let selectedOffer = "";
  let selectedCount = "";
  let selectedPackCount = ""; // effective count for Buy Once when packs are visible (60/120/180)

  const packButtons = productContainer
    ? productContainer.querySelectorAll(".pack-button")
    : [];
  const packGrid = productContainer
    ? productContainer.querySelector("[data-pack-selector]")
    : null;

  // --- CORE FUNCTIONS ---

  const getTargetVariantByOptions = (offer, count) => {
    if (!productData || !offer || !count) return null;
    return productData.variants.find(
      (v) => v.option1 === offer && v.option2 === count,
    );
  };

  const getSellingPlanForVariant = (variantId, planIndex) => {
    const vData = sellingPlansData[variantId];
    if (!vData || !vData.allocations || !vData.allocations[planIndex])
      return null;
    return vData.allocations[planIndex];
  };

  const getSellingPlanByPlanId = (variantId, planId) => {
    const vData = sellingPlansData[variantId];
    if (!vData || !vData.allocations) return null;
    return vData.allocations.find((a) => a.plan_id === planId) || null;
  };

  const getTargetData = (isSubscription, offer, count, planIndex, planId) => {
    let price = 0;
    let compareAt = 0;
    let sellingPlan = "";

    const targetVariant = getTargetVariantByOptions(offer, count);
    if (!targetVariant)
      return { variant: null, price: 0, compareAt: 0, sellingPlan: "" };

    const formulaBase = getFormulaBasePrice(count);

    if (isSubscription) {
      // Prefer lookup by plan ID when available, fall back to index
      const allocation = planId
        ? getSellingPlanByPlanId(targetVariant.id, planId)
        : getSellingPlanForVariant(targetVariant.id, planIndex || 0);
      if (allocation && allocation.price > 0) {
        sellingPlan = allocation.plan_id;
        price = allocation.price;
      } else if (
        targetVariant.selling_plan_allocations &&
        targetVariant.selling_plan_allocations.length > 0
      ) {
        const idx = planIndex || 0;
        const alloc =
          targetVariant.selling_plan_allocations[idx] ||
          targetVariant.selling_plan_allocations[0];
        sellingPlan = alloc.selling_plan_id;
        price =
          alloc.price_adjustments && alloc.price_adjustments[0]
            ? alloc.price_adjustments[0].price
            : targetVariant.price;
      } else {
        price = targetVariant.price;
      }
      compareAt = formulaBase;
    } else {
      price = targetVariant.price;
      compareAt = formulaBase;
    }

    return {
      variant: targetVariant,
      price: price,
      compareAt: compareAt,
      sellingPlan: sellingPlan.toString(),
    };
  };

  const updateBuyOnceLinkPrice = () => {
    const el = document.querySelector(".js-buy-once-link-price");
    if (!el || !selectedOffer || !selectedCount) return;
    // Link always shows the base count price (not pack price)
    const vd = getTargetData(false, selectedOffer, selectedCount, 0);
    if (vd.variant) {
      el.textContent = Shopify.formatMoney(vd.price);
    }
  };

  // --- PACK GRID LOGIC ---

  const getEffectiveBuyOnceCount = () => {
    // When 60 is selected and packs are visible, use the selected pack count
    if (selectedCount === "60" && selectedPackCount) {
      return selectedPackCount;
    }
    return selectedCount;
  };

  const updatePackGridVisibility = () => {
    if (!packGrid) return;
    if (selectedCount === "60") {
      packGrid.classList.add("is-visible");
      packGrid.style.display = "flex";
    } else {
      packGrid.classList.remove("is-visible");
      packGrid.style.display = "none";
      selectedPackCount = selectedCount;
    }
  };

  const updatePackBadges = () => {
    if (!selectedOffer) return;
    ["60", "180", "360"].forEach((count) => {
      const badge = document.querySelector(
        '[data-pack-save-badge="' + count + '"]',
      );
      if (!badge) return;
      const variant = getTargetVariantByOptions(selectedOffer, count);
      if (!variant) {
        badge.textContent = "";
        return;
      }
      const base = getFormulaBasePrice(count);
      const price = variant.price;
      if (base > price && base > 0) {
        const pct = Math.round(((base - price) / base) * 100);
        badge.textContent = "Save " + pct + "%";
      } else {
        badge.textContent = "";
      }
    });
  };

  const updateProductTitle = () => {
    if (!productTitleElement || !baseTitle) return;
    productTitleElement.textContent = baseTitle;
  };

  // --- MAIN UPDATE ---
  const updateFormAndPrices = () => {
    if (!productContainer) return;
    const selectedRadio = productContainer.querySelector(
      'input[name="purchase_option"]:checked',
    );
    if (!selectedRadio || !selectedOffer || !selectedCount) return;

    const purchaseOptionValue = selectedRadio.value;
    const isSubscription = purchaseOptionValue !== "onetime";
    const countMultiplier =
      parseInt(selectedRadio.dataset.countMultiplier, 10) || 1;

    // For subscriptions with a multiplier (e.g. 3-month uses 3× count variant: 30→90, 60→180)
    // For Buy Once, use effective count from pack grid (60/120/180)
    let effectiveCount;
    if (!isSubscription) {
      effectiveCount = getEffectiveBuyOnceCount();
    } else if (countMultiplier > 1) {
      effectiveCount = String(parseInt(selectedCount, 10) * countMultiplier);
    } else {
      effectiveCount = selectedCount;
    }

    // Resolve the correct plan ID from the plan map
    let activePlanId = null;
    if (isSubscription) {
      const flavorPlans =
        planMap[selectedOffer] && planMap[selectedOffer][selectedCount];
      if (flavorPlans) {
        activePlanId =
          countMultiplier > 1 ? flavorPlans.threeMonth : flavorPlans.monthly;
      }
    }

    const finalData = getTargetData(
      isSubscription,
      selectedOffer,
      effectiveCount,
      0,
      activePlanId,
    );

    if (!finalData.variant) return;

    // 1. Update title
    updateProductTitle();

    // 2. Update hidden inputs
    if (variantIdInput) {
      variantIdInput.value = finalData.variant.id;
      variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (subscriptionIdInput) {
      subscriptionIdInput.value = finalData.sellingPlan;
    }

    // 3. Update prices on all purchase option labels + pack badges
    updateAllPurchaseOptionPrices(selectedOffer, selectedCount);
    updatePackGridVisibility();
    updatePackBadges();

    // 4. CTA text
    if (btnTextElement) {
      if (finalData.variant.available) {
        btnTextElement.textContent = "ADD TO CART";
      } else {
        btnTextElement.textContent = "SOLD OUT";
      }
    }

    updateBuyOnceLinkPrice();

    // 5. Shipping text for Buy Once
    if (shippingPriceElement && purchaseOptionValue === "onetime") {
      if (finalData.price >= FREE_SHIPPING_THRESHOLD_CENTS) {
        shippingPriceElement.textContent = "Free Shipping";
        shippingPriceElement.style.fontWeight = "bold";
      } else {
        shippingPriceElement.textContent = DEFAULT_SHIPPING_TEXT;
        shippingPriceElement.style.fontWeight = "normal";
      }
    }

    // 6. Sync selling plan IDs — use planMap to find the correct plan for each radio
    const flavorPlans =
      planMap[selectedOffer] && planMap[selectedOffer][selectedCount];
    productContainer
      .querySelectorAll('input[name="purchase_option"]')
      .forEach((radio) => {
        if (radio.value === "onetime") return;
        const mult = parseInt(radio.dataset.countMultiplier, 10) || 1;
        const radioCount =
          mult > 1 ? String(parseInt(selectedCount, 10) * mult) : selectedCount;
        const radioVariant = getTargetVariantByOptions(
          selectedOffer,
          radioCount,
        );
        if (!radioVariant) return;
        const targetPlanId = flavorPlans
          ? mult > 1
            ? flavorPlans.threeMonth
            : flavorPlans.monthly
          : null;
        const allocation = targetPlanId
          ? getSellingPlanByPlanId(radioVariant.id, targetPlanId)
          : getSellingPlanForVariant(radioVariant.id, 0);
        if (allocation) {
          radio.dataset.sellingPlanId = allocation.plan_id;
          radio.value = "subscription-" + allocation.plan_id;
        }
      });
  };

  const updateAllPurchaseOptionPrices = (currentOffer, currentCount) => {
    // Buy Once price — uses effective count from pack grid
    const effectiveBuyOnceCount = getEffectiveBuyOnceCount();
    const buyOnceLabel = document.querySelector("#buy-once-option");
    if (buyOnceLabel) {
      const variantData = getTargetData(
        false,
        currentOffer,
        effectiveBuyOnceCount,
        0,
      );
      if (variantData.variant) {
        const formulaBase = getFormulaBasePrice(effectiveBuyOnceCount);
        fillPriceDetails(
          buyOnceLabel,
          variantData.price,
          variantData.compareAt,
          formulaBase,
          1,
        );
      }
    }

    // Subscription option prices — each may use a different variant via count multiplier
    if (!productContainer) return;
    const subFlavorPlans =
      planMap[currentOffer] && planMap[currentOffer][currentCount];
    productContainer
      .querySelectorAll(".purchase-option-label:not(.purchase-option-onetime)")
      .forEach((label) => {
        const radioInput = label.querySelector('input[name="purchase_option"]');
        const mult = radioInput
          ? parseInt(radioInput.dataset.countMultiplier, 10) || 1
          : 1;
        const subCount =
          mult > 1 ? String(parseInt(currentCount, 10) * mult) : currentCount;
        const targetPlanId = subFlavorPlans
          ? mult > 1
            ? subFlavorPlans.threeMonth
            : subFlavorPlans.monthly
          : null;
        const variantData = getTargetData(
          true,
          currentOffer,
          subCount,
          0,
          targetPlanId,
        );
        if (variantData.variant) {
          const formulaBase = getFormulaBasePrice(subCount);
          fillPriceDetails(
            label,
            variantData.price,
            variantData.compareAt,
            formulaBase,
            mult,
          );
        }
      });
  };

  // Subscription boxes show the price PER MONTH: the plan total divided by the
  // number of months it covers (Monthly = 1, 3-Month Delivery = 3), suffixed
  // "/mo". The strikethrough base is divided the same way so the "Save X%"
  // badge — computed from the undivided figures — stays unchanged.
  const PER_MONTH_SUFFIX =
    ' / <span style="font-weight:500;font-size:0.8em;">mo</span>';

  const fillPriceDetails = (label, price, compare, formulaBase, months) => {
    const pDisplay = label.querySelector(".current-price-display");
    const cDisplay = label.querySelector(".compare-at-price-display");
    const sLabel = label.querySelector(".savings-label");
    const base = formulaBase || compare;

    // Buy Once: show strikethrough base price, no savings badge
    if (label.classList.contains("purchase-option-onetime")) {
      if (pDisplay) pDisplay.textContent = Shopify.formatMoney(price);
      if (cDisplay) {
        if (base > price) {
          cDisplay.textContent = Shopify.formatMoney(base);
          cDisplay.style.display = "inline";
          cDisplay.style.visibility = "visible";
        } else {
          cDisplay.style.display = "none";
          cDisplay.style.visibility = "hidden";
        }
      }
      if (sLabel) sLabel.style.display = "none";
      return;
    }

    // Subscription: show per-month price + strikethrough base + "Save X%" badge
    const divisor = months && months > 1 ? months : 1;
    const perMonthPrice = Math.round(price / divisor);
    const perMonthBase = Math.round(base / divisor);

    if (pDisplay) {
      pDisplay.innerHTML = Shopify.formatMoney(perMonthPrice) + PER_MONTH_SUFFIX;
    }
    if (cDisplay) {
      if (base > price) {
        cDisplay.textContent = Shopify.formatMoney(perMonthBase);
        cDisplay.style.display = "inline";
        cDisplay.style.visibility = "visible";
      } else {
        cDisplay.style.display = "none";
        cDisplay.style.visibility = "hidden";
      }
    }
    if (sLabel) {
      if (base > price && base > 0) {
        const pct = Math.round(((base - price) / base) * 100);
        sLabel.textContent = `Save ${pct}%`;
        sLabel.style.display = "inline-block";
      } else {
        sLabel.style.display = "none";
      }
    }
  };

  const handlePurchaseOptionChange = (e) => {
    const selectedRadio = e.target;

    purchaseRadios.forEach((radio) => {
      radio.closest("label").classList.remove("is-selected");
    });
    selectedRadio.closest("label").classList.add("is-selected");

    if (selectedRadio.value === "onetime") {
      const buyOnceBox = document.getElementById("buy-once-option");
      if (buyOnceBox) {
        buyOnceBox.style.display = "block";
      }
    }

    updateFormAndPrices();
  };

  // --- LISTENERS ---

  // Offer radios (Sugar free / Low sugar)
  offerRadios.forEach((radio) => {
    if (radio.checked) {
      selectedOffer = radio.value;
    }
    radio.addEventListener("change", (e) => {
      selectedOffer = e.target.value;
      setTimeout(updateFormAndPrices, 50);
    });
  });

  // Count radios (30 / 60) — top-level selector like Nectar's servings
  countRadios.forEach((radio) => {
    if (radio.checked) {
      selectedCount = radio.value;
      selectedPackCount = radio.value;
    }
    radio.addEventListener("change", (e) => {
      selectedCount = e.target.value;
      // Reset pack to default (1-Pack = same count) when top count changes
      selectedPackCount = e.target.value;
      // Reset pack button selection
      packButtons.forEach((btn) => btn.classList.remove("is-selected-pack"));
      const defaultPackBtn = productContainer
        ? productContainer.querySelector(
            '.pack-button[data-pack-value="' + e.target.value + '"]',
          )
        : null;
      if (defaultPackBtn) defaultPackBtn.classList.add("is-selected-pack");
      updateBuyOnceCountLabel();
      setTimeout(updateFormAndPrices, 50);
    });
  });

  // Update the "X yummies" label in the Buy Once box
  const buyOnceCountLabel = document.querySelector(".js-buy-once-count");
  const updateBuyOnceCountLabel = () => {
    if (!buyOnceCountLabel) return;
    const count = getEffectiveBuyOnceCount();
    buyOnceCountLabel.textContent = count + " yummies";
  };

  // Pack buttons (1-Pack/2-Pack/3-Pack inside Buy Once)
  packButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      packButtons.forEach((btn) => btn.classList.remove("is-selected-pack"));
      button.classList.add("is-selected-pack");
      selectedPackCount = button.dataset.packCount;
      updateBuyOnceCountLabel();
      updateFormAndPrices();
    });
  });

  // Purchase option radios
  purchaseRadios.forEach((radio) => {
    radio.addEventListener("change", handlePurchaseOptionChange);
  });

  // --- INIT ---
  const initialOfferRadio = productForm.querySelector(
    'input[name="option1"]:checked',
  );
  if (initialOfferRadio) selectedOffer = initialOfferRadio.value;

  const initialCountRadio = productForm.querySelector(
    'input[name="option2"]:checked',
  );
  if (initialCountRadio) {
    selectedCount = initialCountRadio.value;
    selectedPackCount = initialCountRadio.value;
  }

  if (selectedOffer && selectedCount) {
    const checkedRadio = document.querySelector(
      'input[name="purchase_option"]:checked',
    );
    if (checkedRadio) {
      setTimeout(() => checkedRadio.dispatchEvent(new Event("change")), 100);
    } else {
      updateFormAndPrices();
    }
  }
});
